import React from 'react';
import {Link} from 'react-router';
import './messages.less';
import DashBoardHeader from '../header_dashboard/dashboard_header';
import messageActions from './messages_action';
import authActions from '../auth/auth_actions';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import classNames from 'classnames';
import cookies from '../util/cookie';
import LogoutPopUp from '../components/logoutPopUp/logout_pop_up';
import LoggedinFooter from '../footer/loggedin_footer';

const MediaQuery = require('react-responsive');

class Messages extends React.Component {
    constructor(props) {
        super(props);
        this.renderMessageThread = this.renderMessageThread.bind(this);
        this.logout = this.logout.bind(this);
    }

    logout(){
        this.props.authActions.logout().always(() => {
            cookies.delete('_sd');
            document.location.href = '/';
        });
    }

    renderMessageThread(messageArray) {
        if (messageArray && messageArray.length > 0) {
            return messageArray.map((message, index) => (<MessageThread key={index} message={message}/>));
        }
    }

    render() {
        const self = this;
        const {state, props} = this;
        let {userData} = props.authState;
        let {messages} = props;
        let {actions} = props;
        // data from api call
        let messageArray;
        let shipperMessages = props;
        let carrierMessages;
        let nextUrl = messages.nextUrl;

        let user = {
          name: '',
          imageUrl: '',
          isVerified: '',
          creditAmount: ''
        };

        let sessionValid = true ;

        if("sessionValid" in props.authState.userData){
          sessionValid = props.authState.userData.sessionValid;
        }

        if(props.authState) {
          user.name = userData.name;
          user.imageUrl = userData.profileImageUrl;
          user.isVerified = userData.isVerified;
          user.creditAmount = userData.creditAmount
        }

        user.imageUrl = userData.profileImageUrl || "../../public/images/user_placeholder.svg";

        let messageThreads = this.renderMessageThread(messageArray);

        return (
            <div className="message-page">
              <LogoutPopUp isOpen={!sessionValid}></LogoutPopUp>
              <DashBoardHeader user={user} logout={this.logout} />
              <div className="message-view-wrp">
                  <div className="header">
                      <div id="messageHeader" className="wrapper">
                          Messages
                      </div>
                  </div>
                  {this.props.children}
              </div>
              <LoggedinFooter />
            </div>
        )
    }
}

Messages = connect((state) => {
    return {
      messages: state.app.messages,
      authState: state.app.auth    
    }
}, (dispatch) => {
    return {
        actions: bindActionCreators(messageActions, dispatch),
        authActions : bindActionCreators(authActions, dispatch)
    }
})(Messages);


module.exports = Messages;



// WEBPACK FOOTER //
// app/messages/messages.jsx